import { z } from 'zod';

export enum PromptTypeEnum {
	BUSINESS_SEARCH = 'business-search',
	AI_SNIPPETS = 'ai-snippets',
	AI_SEQUENCES = 'ai-sequences',
	AI_TEMPLATE = 'template-grader'
}

export const sandboxPromptSchema = z.object({
	id: z.string().optional(),
	isDefault: z.boolean().optional(),
	type: z.nativeEnum(PromptTypeEnum),
	name: z.string().min(1, 'Name is required'),
	systemPrompt: z.string().min(1, 'System prompt is required'),
	userPrompt: z.string().min(1, 'User prompt is required'),
	isActive: z.boolean()
});

export type SandboxPromptSchemaProps = z.infer<typeof sandboxPromptSchema>;
